import { Data } from '@angular/router';
import {Component, ContentChild, HostBinding, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
    selector: 'odd-map-content',
    templateUrl: './map-content.component.html',
})

export class MapContentComponent implements OnInit {
    public total: any[];

    @Input() public readonly model: Data[];
    @Input() public readonly index: number;
    @Input() public readonly className: string;

    @ContentChild(TemplateRef, { static: false }) public blockItemTmpl: TemplateRef<any>;

    public ngOnInit(): void {
        this.total = new Array(+this.index);
    }
}
